import { TrashIcon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

// import { DataTableFacetedFilter } from "./data-table-faceted-filter";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  // const isFiltered = table.getState().columnFilters.length > 0;

  const deleteSelectedRows = () => {
    const selectedRows = table.getSelectedRowModel().rows;

    const indexes = selectedRows.map((row) => row.index);

    // @ts-ignore
    table.options.meta?.removeRow(indexes);

    table.toggleAllPageRowsSelected(false);
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center justify-end space-x-2">
        {table.getSelectedRowModel().rows.length > 0 && (
          <Button
            aria-label="Delete selected rows"
            variant="destructive"
            size="sm"
            className="h-8 self-end"
            type="button"
            onClick={deleteSelectedRows}
          >
            <TrashIcon className="mr-2 size-4" aria-hidden="true" />
            Delete
          </Button>
        )}
        {/* {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )} */}
      </div>
    </div>
  );
}
